/**
 * @generated SignedSource<<fa2fab823f1b84f41f99562c853af4ab>>
 * @relayHash 435fd7884549195e737f35afe509db11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cceb9b662204567ea34c895cb9752b015b691a5fba2b08847d2c39472f37e70e

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceUpdateContentDirectRestrictionsInput = {
  add?: ConfluenceDirectRestrictionsAddInput | null | undefined;
  contentId: string;
  includeInvites?: boolean | null | undefined;
  remove?: ConfluenceDirectRestrictionsRemoveInput | null | undefined;
};
export type ConfluenceDirectRestrictionsAddInput = {
  edit?: ConfluenceRestrictionsInput | null | undefined;
  view?: ConfluenceRestrictionsInput | null | undefined;
};
export type ConfluenceRestrictionsInput = {
  restrictions: ReadonlyArray<ConfluenceRestrictionInput | null | undefined>;
};
export type ConfluenceRestrictionInput = {
  principalId: string;
  principalType: ConfluencePrincipalType;
};
export type ConfluenceDirectRestrictionsRemoveInput = {
  edit?: ConfluenceRestrictionsInput | null | undefined;
  view?: ConfluenceRestrictionsInput | null | undefined;
};
export type useUpdateContentDirectRestrictionsMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateContentDirectRestrictionsInput;
};
export type useUpdateContentDirectRestrictionsMutation$data = {
  readonly confluence_updateContentDirectRestrictions: {
    readonly contentDirectRestrictions: {
      readonly applied: {
        readonly added: {
          readonly edit: {
            readonly __typename: "ConfluenceRestrictionsResult";
            readonly restrictions: ReadonlyArray<{
              readonly principalId: string;
              readonly principalType: ConfluencePrincipalType;
            } | null | undefined>;
          } | null | undefined;
          readonly view: {
            readonly __typename: "ConfluenceRestrictionsResult";
            readonly restrictions: ReadonlyArray<{
              readonly principalId: string;
              readonly principalType: ConfluencePrincipalType;
            } | null | undefined>;
          } | null | undefined;
        } | null | undefined;
        readonly removed: {
          readonly edit: {
            readonly __typename: "ConfluenceRestrictionsResult";
            readonly restrictions: ReadonlyArray<{
              readonly principalId: string;
              readonly principalType: ConfluencePrincipalType;
            } | null | undefined>;
          } | null | undefined;
          readonly view: {
            readonly __typename: "ConfluenceRestrictionsResult";
            readonly restrictions: ReadonlyArray<{
              readonly principalId: string;
              readonly principalType: ConfluencePrincipalType;
            } | null | undefined>;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly confluencePermissionsSummary: {
        readonly __typename: "ConfluencePermissionsSummary";
        readonly limit: number;
        readonly remainingSlots: number;
        readonly totalCount: number;
        readonly totalGroups: number;
        readonly totalTeams: number;
        readonly totalUsers: number;
      };
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type useUpdateContentDirectRestrictionsMutation = {
  response: useUpdateContentDirectRestrictionsMutation$data;
  variables: useUpdateContentDirectRestrictionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "concreteType": "ConfluenceRestriction",
    "kind": "LinkedField",
    "name": "restrictions",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "principalId"
      },
      {
        "kind": "ScalarField",
        "name": "principalType"
      }
    ]
  },
  (v1/*: any*/)
],
v3 = [
  {
    "concreteType": "ConfluenceRestrictionsResult",
    "kind": "LinkedField",
    "name": "edit",
    "plural": false,
    "selections": (v2/*: any*/)
  },
  {
    "concreteType": "ConfluenceRestrictionsResult",
    "kind": "LinkedField",
    "name": "view",
    "plural": false,
    "selections": (v2/*: any*/)
  }
],
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateContentDirectRestrictionsPayload",
    "kind": "LinkedField",
    "name": "confluence_updateContentDirectRestrictions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceContentDirectRestrictions",
        "kind": "LinkedField",
        "name": "contentDirectRestrictions",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceDirectRestrictionsApplied",
            "kind": "LinkedField",
            "name": "applied",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceDirectRestrictionsResult",
                "kind": "LinkedField",
                "name": "added",
                "plural": false,
                "selections": (v3/*: any*/)
              },
              {
                "concreteType": "ConfluenceDirectRestrictionsResult",
                "kind": "LinkedField",
                "name": "removed",
                "plural": false,
                "selections": (v3/*: any*/)
              }
            ]
          },
          {
            "concreteType": "ConfluencePermissionsSummary",
            "kind": "LinkedField",
            "name": "confluencePermissionsSummary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "limit"
              },
              {
                "kind": "ScalarField",
                "name": "remainingSlots"
              },
              {
                "kind": "ScalarField",
                "name": "totalCount"
              },
              {
                "kind": "ScalarField",
                "name": "totalGroups"
              },
              {
                "kind": "ScalarField",
                "name": "totalTeams"
              },
              {
                "kind": "ScalarField",
                "name": "totalUsers"
              },
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUpdateContentDirectRestrictionsMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateContentDirectRestrictionsMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "435fd7884549195e737f35afe509db11",
    "id": "cceb9b662204567ea34c895cb9752b015b691a5fba2b08847d2c39472f37e70e",
    "metadata": {},
    "name": "useUpdateContentDirectRestrictionsMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateContentDirectRestrictionsMutation($cloudId:ID!,$input:ConfluenceUpdateContentDirectRestrictionsInput!){confluence_updateContentDirectRestrictions(cloudId:$cloudId,input:$input){success,errors{message},contentDirectRestrictions{applied{added{edit{restrictions{principalId,principalType},__typename},view{restrictions{principalId,principalType},__typename}},removed{edit{restrictions{principalId,principalType},__typename},view{restrictions{principalId,principalType},__typename}}},confluencePermissionsSummary{limit,remainingSlots,totalCount,totalGroups,totalTeams,totalUsers,__typename}}}}"
  }
};
})();

(node as any).hash = "8e3f15844ecf45b96c187715ccd59883";

export default node;
